import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { APIError, get, post, put, remove } from '../services/crud'
import { ISearchResponse } from '@sales-center/common'
import { SalesCenterWebhook } from '@user/store/scWebHooks/typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.webHooks.scWebHooks}`

export const getAllSCWebHooks = createAsyncThunk<SalesCenterWebhook[]>(
  'SalesCenterWebhooks/Registration',
  async (_, thunkApi) => {
    const response = await get(baseUrl)
    if (response.ok) {
      return await response.json()
    }
    return thunkApi.rejectWithValue(await response.json())
  },
)

export const getSelectedSCWebHook = createAsyncThunk<
  SalesCenterWebhook,
  number,
  { rejectValue: string }
>('SalesCenterWebhooks/Registration/id', async (webHookId, thunkApi) => {
  const response = await get(`${baseUrl}/${webHookId}`)

  if (response.ok) {
    const payload: ISearchResponse<SalesCenterWebhook> = await response.json()
    return payload.items[0]
  }
  return thunkApi.rejectWithValue(await response.json())
})

export const createSCWebHook = createAsyncThunk<
  SalesCenterWebhook,
  SalesCenterWebhook
>('SalesCenterWebhooks/Registration/create', async (webHook, thunkApi) => {
  const response = await post(`${baseUrl}`, webHook)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const updateSCWebHook = createAsyncThunk<
  SalesCenterWebhook,
  SalesCenterWebhook,
  { rejectValue: APIError }
>('SalesCenterWebhooks/Registration/update', async (webHook, thunkApi) => {
  const response = await put(`${baseUrl}/${webHook.id}`, webHook)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const deleteSCWebHook = createAsyncThunk<string, string>(
  'SalesCenterWebhooks/Registration/delete',
  async (id, thunkApi) => {
    const response = await remove(`${baseUrl}/${id}`)
    if (response.ok) return id
    return thunkApi.rejectWithValue(await response.json())
  },
)
